module.exports = __webpack_public_path__ + "static/media/gryphon_musee_ids_dimopoulos_1.f72e3d1c.jpg";